import { TOP_NAV_ITEMS } from "./TopNavigationData2";
import TopNavigationListItem3 from "./TopNavigationListItem3";
import TopNavigationSubMenu3 from "./TopNavigationSubMenu3";

const HeaderNavBar3 = () => {

  return (
    <>
      {TOP_NAV_ITEMS.map((item, index) => {
        if (item.type === "listItem") {
          return <TopNavigationListItem3 classNames="body semibold lh-1" key={"topRespNav" + index} listItemTitle={item.title} listItemLink={item.link}></TopNavigationListItem3>
        }
        if (item.type === "subMenu") {
          return <TopNavigationSubMenu3 key={"topRespNav" + index} subMenuButtonTitle={item.title} subMenuId={item.id} subMenuItems={item.items}></TopNavigationSubMenu3>
        }
      })}
    </>
  )
}

export default HeaderNavBar3;